import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  invoiceCardContainer: {
    backgroundColor: '#F9F9F9',
    maxWidth: 250,
    padding: '16px 24px',
    width: '100%',
  },
  listItem: {
    width: '100%',
    padding: '0 4px 0 0',
    borderBottom: `1px solid ${theme.palette.dividers.primary}`,

    '&:last-child': {
      border: 0,
      '& .MuiListItemText-secondary': {
        color: theme.palette.primary.main,
        fontSize: theme.typography.pxToRem(16),
        fontWeight: theme.typography.fontWeightMedium,
      },
    },
  },
}));

const listTextStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      textAlign: 'right',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    primary: {
      color: theme.palette.text.subtitle,
      fontSize: theme.typography.pxToRem(13),
      fontWeight: theme.typography.fontWeightBold,
      wordBreak: 'break-word',
    },

    secondary: {
      color: theme.palette.text.subtitle,
      fontSize: theme.typography.pxToRem(13),
      wordBreak: 'break-word',
    },
  };
});

export { useStyles, listTextStyles };
